/* app/js/src/components/graphics/edit/edit-graphics-aside.component.scss */
.cursor-pointer {
  cursor: pointer;
}
footer > div input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
footer > div input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
footer > div input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
footer > div input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
footer > div input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
footer > div input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
footer > div input.ng-invalid.ng-dirty,
footer > div input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
.live-button,
footer > div .save-btn,
.autopilot-btn {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.live-button:focus,
footer > div .save-btn:focus,
.autopilot-btn:focus {
  outline-color: #ffffff;
}
.live-button:hover,
footer > div .save-btn:hover,
.autopilot-btn:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.live-button,
footer > div .disabled.save-btn,
.disabled.autopilot-btn {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.container {
  background-color: #f1f3f4;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 17px 5% 27px 5%;
}
.rounded-btn,
.rounded-btn-prev {
  display: inline-block;
  background: #ffffff no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
}
.rounded-btn-prev {
  background-image: url(/assets/icons/prev.svg);
}
nav {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
nav .back {
  margin-right: 12px;
  color: #879baf;
  font-size: 10px;
  letter-spacing: 0.1px;
}
.autopilot-btn {
  background-color: #a65bfa;
  display: inline-block;
  height: 28px;
  width: 132px;
  text-align: center;
}
.graphics-video-preview {
  position: relative;
  top: 3.2%;
  height: 30%;
  margin-bottom: 3.2%;
  z-index: 4;
}
.graphics-name {
  font-size: 20px;
  color: #232f3a;
  margin-top: 20px;
}
.details {
  flex-direction: column;
  margin-top: 16px;
}
.details .left-side {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.details .buttons {
  margin-top: 23px;
}
.details .aspect-ratio {
  font-size: 10px;
  letter-spacing: normal;
  color: #232f3a;
}
.details .aspect-ratio label {
  color: #879baf;
}
.details .duration {
  margin-top: 12px;
  font-size: 14px;
  letter-spacing: 0.1px;
  color: #232f3a;
}
.details {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
main {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
footer label {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  display: inline-block;
  margin-bottom: 15px;
}
footer > div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
footer > div input {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
footer > div .save-btn {
  margin-left: 13px;
}
.live-button {
  width: 99px;
  height: 28px;
  background-color: #ef5350;
  text-align: center;
  margin-left: 10px;
}
/*# sourceMappingURL=edit-graphics-aside.component.css.map */
